export default {"src":"/_next/static/media/content-folder.d518f122.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};